
import WebFont from 'webfontloader'

const options = {"custom":{"families":["VAG Rounded Std"],"urls":["\u002Fcss\u002Ffonts.css"]}}

WebFont.load(options)
